export const signIn = (credentials) => {
    return (dispatch, getState, { getFirebase }) => {
        const firebase = getFirebase();

        firebase.auth().signInWithEmailAndPassword(
            credentials.email,
            credentials.password
        ).then(() => {
            dispatch({ type: 'LOGIN_SUCCESS' })
        }).catch((error) => {
            dispatch({ type: 'LOGIN_ERROR', error })
        })
    }
}

export const signOut = () => {
    return (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();

        firebase.auth().signOut().then(() => {
            dispatch({ type: "SIGNOUT_SUCCESS" });
        });
    }
}

export const signUp = (newUser) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const firebase = getFirebase();
        const firestore = getFirestore();

        firebase.auth().createUserWithEmailAndPassword(
            newUser.email,
            newUser.password
        ).then((response) => {
            return firestore.collection("users").doc(response.user.uid).set({
                firstName: newUser.firstName,
                lastName: newUser.lastName,
                initials: newUser.firstName[0] + newUser.lastName[0]
            })
        }).then(() => {
            dispatch({ type: "SIGNUP_SUCCESS "})
        }).catch((error) => {
            dispatch({ type: "SIGNUP_ERROR", error })
        })
    }
}

export const deleteAccount = () => {
    return (dispatch, getState, { getFirebase, getFirestore }) => { // know what to connect to because of the config passed in index js file
        const firebase = getFirebase();

        const user = firebase.auth().currentUser;

        if(window.confirm("Are you sure you want to delete your account?")) {
            user.delete().then(() => {
                dispatch({ type: "DELETE_ACCOUNT_SUCCESS"})
            }).catch(function(error) {
                dispatch({ type: "DELETE_ACCOUNT_ERROR", error })
            }); 
        }
    } 
}